import { CATEGORIAS_ACOPIO } from "../../../../../utility/constants";

export const CONFIG_TEXTOS_ACOPIO = {
    [CATEGORIAS_ACOPIO.PLANTA]: {
        textoEnvio: "Enviado a producción",
        textoRecepcionesSobrante: "Recepciones no enviadas a producción",
        destinoEnvio: "producción",
        mostrarNotaReproceso: true,
    },
    [CATEGORIAS_ACOPIO.ACOPIO]: {
        textoEnvio: "Enviado a planta",
        textoRecepcionesSobrante: "Recepciones no enviadas a planta",
        destinoEnvio: "planta",
        mostrarNotaReproceso: false,
    },
};
